
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { RegistroIngSalCodManualComponent } from './registrar-ing-sal-cod-manual.component';
import { RegistroIngSalCodManualRoutingModule } from './registrar-ing-sal-cod-manual-routing.module';



@NgModule({
    declarations: [RegistroIngSalCodManualComponent],
    imports: [
        SharedModule,
        CommonModule,
        RegistroIngSalCodManualRoutingModule

    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class RegistroIngSalCodigoManualModule { }
